import { AccountInfo, IPublicClientApplication } from '@azure/msal-browser';

export const loginRequest = { scopes: ['User.Read'] };

export function login(instance: IPublicClientApplication) {
  instance
    .loginRedirect(loginRequest)
    .catch((e) => console.error('Error login:', e));
}

export function logout(instance: IPublicClientApplication) {
  instance.logoutRedirect().catch((e) => console.log('Error logging out', e));
}

export function getUserRole(accounts: AccountInfo[]) {
  if (!accounts || !accounts.length || !accounts[0].idTokenClaims?.roles) {
    throw new Error('User has not logged in');
  }

  return accounts[0].idTokenClaims?.roles[0];
}
